import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'batch-send-partial-notification',
  templateUrl: './batch-send-partial-notification.component.html',
  styleUrls: ['./batch-send-partial-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchSendPartialNotificationComponent {
  @Input() public header: string;
  @Input() public hint: string;
}
